import { Component, OnInit } from '@angular/core';
import { User } from '../user';
import { UserAuthService } from '../user-auth.service';
import { AuthResponse } from '../auth-response';
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
    user: User = new User;
errorMessage: string;
succMessage: string;
isLoading: boolean;
  constructor(  private userAuthService: UserAuthService) { 
    
}

  ngOnInit() {
  }
  clickSubmit( email: string ) {
		this.setUserEmail(email);
		this.sendPasswordResetLink(email);
	}

	setUserEmail( email: string ) {
		this.user.email = email;
	}

sendPasswordResetLink(email: string) {

		this.isLoading = true;

		this.userAuthService.generateResetPasswordLink(email)
							.finally( // triggers independently of success or error
								() => {
									this.isLoading = false;
								}
							)
							.subscribe(
								(authenticatedUser: AuthResponse) => {
									if ( authenticatedUser.success ) {
										this.succMessage = authenticatedUser.message;
                                                                                this.errorMessage="";
                                                                        } else {
										this.errorMessage = authenticatedUser.message;
                                                                                this.succMessage="";
									}
								},
								error => {
									this.errorMessage = 'Feil brukernavn eller passord';
								}
							)

	}
}



// WEBPACK FOOTER //
// ./src/app/forgot-password/forgot-password.component.ts